import { ShortcutLayer } from '@/utils/shortcut'

/**
 * 页面 / 弹窗接入快捷键中心。
 * Phase 1 没有任何界面引入本 mixin；后续在 created/mounted 里调用 bindShortcuts。
 *
 * @example
 * mixins: [useShortcuts]
 * mounted() {
 *   this.bindShortcuts({ space: this.handleConfirmBefore }, { layer: 'page', onScan: this.handleScanAddGoods })
 * }
 */
export default {
  created() {
    this._shortcutScopeId = `scope-${this._uid}`
    this._shortcutRegistered = false
  },

  activated() {
    if (this._shortcutRegistered) {
      this.$shortcuts.activate(this._shortcutScopeId)
    }
  },

  deactivated() {
    if (this._shortcutRegistered) {
      this.$shortcuts.deactivate(this._shortcutScopeId)
    }
  },

  beforeDestroy() {
    if (this._shortcutRegistered) {
      this.$shortcuts.unregister(this._shortcutScopeId)
      this._shortcutRegistered = false
    }
  },

  methods: {
    /**
     * 向中心登记 keymap。keep-alive 下由 activated/deactivated 自动启停。
     * @param {Object} keys Mousetrap 键名 -> handler
     * @param {Object} options
     * @param {string} [options.layer=page] app | page | dialog | widget
     * @param {Function} [options.onScan] 扫码接收口
     * @param {boolean} [options.exclusive] dialog 默认 true
     * @param {boolean} [options.enterInInput] 焦点在输入框时仍响应 enter
     * @param {string} [options.id] 自定义 scope id
     */
    bindShortcuts(keys, options = {}) {
      const layer = options.layer || ShortcutLayer.PAGE
      if (options.id) this._shortcutScopeId = options.id
      this.$shortcuts.register({
        id: this._shortcutScopeId,
        layer,
        keys: keys || {},
        onScan: options.onScan || null,
        exclusive: options.exclusive,
        enterInInput: options.enterInInput,
        vm: this,
        strictDigitBuffer: options.strictDigitBuffer,
        onDigitReplay: options.onDigitReplay || null,
      })
      this._shortcutRegistered = true
      this.$shortcuts.activate(this._shortcutScopeId)
    },

    unbindShortcuts() {
      if (!this._shortcutRegistered) return
      this.$shortcuts.unregister(this._shortcutScopeId)
      this._shortcutRegistered = false
    },
  },
}
